module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Cooking/Fork-spoon-8bffc05421281595b572159a14a9f7b7.svg";